import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/transaction.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";

function Transaction() {
    const [usersData, setUsersData] = useState(null);
    const config = configModule.config();
    const [firstTransact, setFirstTransact] = useState("");
    const [transaction, setTransaction] = useState([]);

    const getTransactionData = async () => {

        try {
            const response = await axios.get(
                `${config.apiBaseUrl}/get-transaction/${usersData?.id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const init = response.data?.init;
            const data = response.data?.data;
            setFirstTransact(init);
            setTransaction(data);


        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Something went wrong";

            toast.error(message);
        }
    };

    useEffect(() => {
        if (usersData?.id) {
            getTransactionData();
        }
    }, [usersData]);


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            const decoded = jwtDecode(token);
            setUsersData(decoded);
        }
    }, []);

    const formatIndianCurrency = (value) => {
        if (value === null || value === undefined || value === '') return '₹0';

        const num = Number(value);
        if (isNaN(num)) return '₹0';

        const absNum = Math.abs(num);
        const sign = num < 0 ? '-' : '';

        let formatted;
        if (absNum >= 10000000) {
            // Crore
            formatted = (absNum / 10000000).toFixed(absNum % 10000000 === 0 ? 0 : 2) + 'Cr';
        } else if (absNum >= 100000) {
            // Lakh
            formatted = (absNum / 100000).toFixed(absNum % 100000 === 0 ? 0 : 2) + 'L';
        } else if (absNum >= 1000) {
            // Thousand
            formatted = (absNum / 1000).toFixed(absNum % 1000 === 0 ? 0 : 2) + 'K';
        } else {
            formatted = absNum.toString();
        }

        return `₹${sign}${formatted}`;
    };


    const formatPaymentDate = (date) => {
        if (!date) return "";

        return new Date(date).toLocaleString("en-US", {
            month: "short",
            year: "numeric",
            day: "numeric"
        });
    };

    return (
        <div className='dashboardmain-st'>
            <Header pageName="My Portfolio" />
            <div className="body-dashboard">
                <div className="page-header">
                    <div className="page-eyebrow">Ledger</div>
                    <div className="page-title">Transactions</div>
                </div>

                <div className="lxp-card">
                    {transaction?.length > 0 && transaction.map((item, index) => (
                        <div className="lxp-txn-row" key={index}>
                            {item.status === "Paid" && (
                                <div className="lxp-txn-icon in">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <line x1="12" y1="19" x2="12" y2="5"></line>
                                        <polyline points="5 12 12 5 19 12"></polyline>
                                    </svg>
                                </div>
                            )}
                            {item.status === "Pending" && (
                                <div className="lxp-txn-icon processing">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M21 12a9 9 0 1 1-2.64-6.36" />
                                        <polyline points="21 3 21 9 15 9" />
                                    </svg>
                                </div>
                            )}
                            {item.status === "Delayed" && (
                                <div className="lxp-txn-icon delayed">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <circle cx="12" cy="12" r="9" />
                                        <polyline points="12 7 12 12 16 14" />
                                    </svg>
                                </div>
                            )}

                            {item.transaction_type === "Addon" && (
                                <div className="lxp-txn-icon out">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <polyline points="19 12 12 19 5 12"></polyline>
                                    </svg>
                                </div>
                            )}
                            <div>
                                <div className="lxp-txn-title">{item.transaction_type === "Addon" ? "Investment — Phase 1": (item.status === "Paid" ? "Return Payout — Phase 1" : (item.status === "Pending" ? "Pending Payout — Phase 1" : "Delayed Payout — Phase 1"))}</div>
                                <div className="lxp-txn-sub">{item?.transaction_date ? formatPaymentDate(item?.transaction_date) : ""} · {item?.payment_mode || ""}</div>
                            </div>
                            <div
                                className={`lxp-txn-amt ${item?.transaction_type === "Return" && (item.status === "Paid"
                                    ? "green"
                                    : item.status === "Pending"
                                        ? "yellow"
                                        : "red"
                                )}`}
                            >
                                {item.status === "Paid" && "+ "}{item?.amount ? formatIndianCurrency(item?.amount) : 0}
                            </div>
                        </div>
                    ))}

                    <div className="lxp-txn-row">
                        <div className="lxp-txn-icon out">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <polyline points="19 12 12 19 5 12"></polyline>
                            </svg>
                        </div>
                        <div>
                            <div className="lxp-txn-title">Investment — Phase 1</div>
                            <div className="lxp-txn-sub">{firstTransact?.invesment_date ? formatPaymentDate(firstTransact?.invesment_date) : ""}</div>
                        </div>
                        <div className="lxp-txn-amt">{formatIndianCurrency(firstTransact?.total_invesment || 0)}</div>
                    </div>
                </div>
            </div>

            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: "#0a1628",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "14px 18px",
                    },
                    success: {
                        iconTheme: {
                            primary: "#22c55e",
                            secondary: "#fff",
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: "#ef4444",
                            secondary: "#fff",
                        },
                    },
                }}
            />
        </div>
    )
}

export default Transaction;
